import { reactive } from 'vue';
import { defineStore } from 'pinia';
import { assignState } from '@/store/index.js';
import { bundleTypeEnum } from '@/constants/bundle.js';
import { apiRetrieveBundles } from '@/services/bundle.js';

const getBundleListPerTypeDefaultState = () => ({
  [bundleTypeEnum.GAMES]: [],
  [bundleTypeEnum.JOKERS]: [],
});

const useBundleStore = defineStore('bundle', () => {
  const bundleListPerType = reactive(getBundleListPerTypeDefaultState());

  const dispatchRetrieveBundles = async () => {
    try {
      const { groupedData } = await apiRetrieveBundles();

      assignState(bundleListPerType, groupedData);
    } catch (error) {
      return Promise.reject(error);
    }
  };

  return {
    bundleListPerType,
    dispatchRetrieveBundles,
  };
});

export default useBundleStore;
